import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import Adres from '@components/Adres'
import { DisciplineIcon } from '@components/DisciplineIcon'
import { formatDateTime } from '@util/date-util'

import type { HoofdnetOpdracht } from '../types/HoofdnetOpdracht'

interface Props {
  opdracht: HoofdnetOpdracht
}

export const HoofdnetOpdrachtDetails = ({ opdracht }: Props) => {
  const { opdrachtgever, opdrachtnemer, type, changed, versieNummer, created } =
    opdracht

  const items = [
    { title: 'Type', text: type },
    { title: 'Versienummer', text: versieNummer },

    {
      title: 'Discipline',
      text: (
        <DisciplineIcon
          disciplineCode={opdracht.details?.discipline || ''}
          toolTip={opdracht.details?.disciplineLabel || ''}
        />
      ),
      jsx: true,
    },
    {
      title: 'Adres',
      text: opdracht.details?.adres && (
        <Adres
          {...opdracht.details.adres}
          straatNaam={opdracht.details.adres.straat}
        />
      ),
    },
    { title: 'Opdrachtnemer', text: opdrachtnemer },
    { title: 'Opdrachtgever', text: opdrachtgever },
    { title: 'Creatiedatum', text: formatDateTime(created) },
    { title: 'Mutatiedatum', text: formatDateTime(changed) },
    { title: 'ClustercodeNB', text: opdracht.details?.clusterCodeNB },
    { title: 'ClusterId', text: opdracht.details?.clusterId },
  ]

  return (
    <>
      <Grid container spacing={2} sx={{ m: 'auto', width: '95%', p: 1 }}>
        {generateTextItems(items)}
      </Grid>
    </>
  )
}

/** Generard a `Grid` > `Typography` or `Grid` > `DisciplineIcon` based on an array. Used for less code duplication */
function generateTextItems(items) {
  return (
    <>
      {items.map((item) => {
        return (
          <Grid key={`${item.title}-${item.text}`} size={{ xs: 3 }}>
            <Typography gutterBottom variant="subtitle1">
              <b>{item.title}</b>
            </Typography>
            {item.jsx ? (
              item.text
            ) : (
              <Typography variant="body2">{item.text}</Typography>
            )}
          </Grid>
        )
      })}
    </>
  )
}
